export enum AssignmentDrivability {
  Drivable = 0,
  NotDrivable = 1,
  NotRollable = 2,
}
